
import React,{Component,PropTypes} from 'react';
import {isNullOrEmpty} from "../actions/website-actions";
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import * as sActs from '../actions/server-actions';
import {Link} from 'react-router-dom';
class BreadCrumbs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      type: props.type
    }
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }




  render() {


    if(wActs.isNullOrUndefined(this.props.WebPage.Page)) { return null; }
    if(this.props.WebPage.UCMode) { return null; }

    let total = this.props.WebPage.Page.Breadcrumbs.length-1;
    let mob = this.props.WebPage.Device.IsMobileDevice;
    if(total<=-1) {
      return (<div className="breadcrumbs"></div>);
    }

    return (
      <div className="breadcrumbs">
        <div className="container">
          <div className={`cell x12 ${this.props.PageType=="home" ? "bc-wrap" : "bc-wrap"}`}>
            <ol vocab="http://schema.org/" typeof="BreadcrumbList">
              {this.props.WebPage.Page.Breadcrumbs.map((v,i) => {
                let reg = /.+?\:\/\/.+?(\/.+?)(?:#|\?|$)/;
                //console.log(v.Url)
                let pathmatch = reg.exec( v.Url );
                let pathname = "/";
                if(pathmatch !== null && pathmatch.length>=2) { pathname=pathmatch[1]; }

                /*<li  style={{textTransform: "capitalize"}}><Link to={pathname} title={v.Description}>{v.Title.split("|")[0]}</Link></li>*/
                return (
                  <React.Fragment key={"bc-" + i}>
                  {i < total &&
                  <li property="itemListElement" typeof="ListItem">
                    <Link property="item" typeof="WebPage" to={pathname}>
                      <span property="name">{v.Title}</span>
                    </Link>
                    <meta property="position" content={i}/>
                  </li>
                  }
                  </React.Fragment>
                );
              })}
            </ol>
            {!wActs.isNullOrUndefined(this.props.WebPage.Page.Breadcrumbs[total]) &&
            <span className={this.props.WebPage.PageType == "home" ? "lbw" : "lbc"}>{this.props.WebPage.Page.Breadcrumbs[total].Title}</span>
            }
            {!mob &&
            <div className="socials">
              <ul>
                {!wActs.isNullOrEmpty(this.props.WebPage.Settings.TwitterUrl) &&
                <li><a href={this.props.WebPage.Settings.TwitterUrl} target="_blank" style={{background: "#00acee"}}><i className="fab fa-twitter"></i></a></li>
                }
                {!wActs.isNullOrEmpty(this.props.WebPage.Settings.FacebookUrl) &&
                <li><a href={this.props.WebPage.Settings.FacebookUrl} target="_blank" style={{background: "#3b5998"}}><i className="fab fa-facebook-f"></i></a></li>
                }
                {!wActs.isNullOrEmpty(this.props.WebPage.Settings.InstagramUrl) &&
                <li><a href={this.props.WebPage.Settings.InstagramUrl} target="_blank" style={{background: "#F44747"}}><i className="fab fa-instagram"></i></a></li>
                }
                {!wActs.isNullOrEmpty(this.props.WebPage.Settings.TelegramUrl) &&
                <li><a href={this.props.WebPage.Settings.TelegramUrl} target="_blank" style={{background: "#0088cc"}}><i className="fab fa-telegram-plane"></i></a></li>
                }
              </ul>
            </div>
            }
          </div>
          <div className="clear"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    PageType: state.Website.PageType
  };
}

export default connect(mapStateToProps)(BreadCrumbs);




